import ErrorModal from "@/components/modais/ErrorModal.vue";
import { HTTP_RESPONSE } from "@/constants/strings";
import { logoutFromSSO, useRefreshToken } from "@/utils/authentication";
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions(["ActionSetToken"]),
    mxHandleRequestError({ response }, entity = "") {
      if (!response) {
        return this.mxToggleErrorMessageAlert(
          "Ocorreu um erro ao processar sua solicitação: serviço indisponível"
        );
      }
      const { status } = response;
      if (!status) {
        return this.mxToggleErrorMessageAlert(
          "Ocorreu um erro ao processar sua solicitação: serviço indisponível"
        );
      }
      if ([401, 403].includes(status)) {
        if (entity.toUpperCase() === "LOGIN") {
          return ErrorModal.show(HTTP_RESPONSE.USUARIO.ERROR[status]);
        }
        useRefreshToken()
          .then(() => {
            window.sessionStorage.setItem("was_token_recently_refreshed", true);
            this.ActionSetToken(
              window.sessionStorage.getItem(process.env.VUE_APP_TOKEN_KEY)
            );
          })
          .catch(() => {
            this.mxToggleWarningModal(
              HTTP_RESPONSE.GENERIC[403],
              "Prosseguir",
              null,
              "ATENÇÃO",
              false,
              true
            )
              .then()
              .catch()
              .finally(() => {
                logoutFromSSO();
              });
          });
        return;
      }
      const msg =
        HTTP_RESPONSE[entity.toUpperCase()]?.ERROR[status]?.(response) ||
        HTTP_RESPONSE[entity.toUpperCase()]?.ERROR[status] ||
        response?.data?.message ||
        HTTP_RESPONSE.GENERIC[status];
      if (msg) {
        this.mxToggleErrorMessageAlert(msg);
      } else {
        this.mxToggleErrorMessageAlert(
          "Ocorreu um erro interno ao processar sua solicitação"
        );
      }
    },
  },
};
